const IOS_HOTEL_DOWNLOAD_LINK = 'https://itunes.apple.com/app/id1614894754';
const IOS_GUEST_DOWNLOAD_LINK = 'https://itunes.apple.com/app/id1557539492';
const ANDROID_GUEST_DOWNLOAD_LINK =
  'https://play.google.com/store/apps/details?id=com.resortpass.app';

export { ANDROID_GUEST_DOWNLOAD_LINK, IOS_GUEST_DOWNLOAD_LINK, IOS_HOTEL_DOWNLOAD_LINK };
